import React, { useState, useContext, useEffect } from 'react';
import { getToken, getLikes, saveLike } from "../../../services/social.services";
import GlobalContext from "../../../contexts/globalContext";
import "./like-dislike.scss";
import ModalGuiaCdc from '../../molecules/modal-guia-cdc/modalGuiaCdc';

const LikeButtonGroup = (props:any) => {

  const Context = useContext(GlobalContext);
  const [utilFlag, setUtilFlag] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [likedByUserLocal, setLikedByUserLocal] = useState(false);
  const [likeCountLocal, setLikeCountLocal] = useState(0);
  const [disLikeCountLocal, setDisLikeCountLocal] = useState(0);
  const [likeTypeByUser, setLikeTypeByUser] = useState(-1);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  
  const getLikesData = async () => {
    if (props.contentId) {
      const email = Context.gigyaContext.gigyaAccount ? Context.gigyaContext.gigyaAccount.profile.email : null;
      const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
      const response = await getLikes(props.contentId, props.contentType, email, token);
      setLikeTypeByUser(response.data.data.likeTypeByUser);
      setLikedByUserLocal(response.data.data.likedByUser);
      setLikeCountLocal(response.data.data.likesTotales);
      setDisLikeCountLocal(response.data.data.disLikesTotales);
    }
  };

  const saveLikeData = async (contentId, contentType, removeLike, likeType) => {
      const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
      const data:any = {
          "usuarioDoc": Context.gigyaContext.gigyaAccount?.data.docNumber,
          "usuarioEmail": Context.gigyaContext.gigyaAccount!.profile.email,
          "usuarioNombre": Context.gigyaContext.gigyaAccount!.profile.firstName + " " + Context.gigyaContext.gigyaAccount!.profile.lastName,
          "usuarioFoto": Context.gigyaContext.gigyaAccount?.profile.photoURL,
          "contenidoId": contentId,
          "contenidoTipo": contentType,
          "likeType": likeType,
          "remove": removeLike
      };
      const newData = await saveLike(data, token);
      setLikeTypeByUser(newData.data.data.likeTypeByUser);
      setLikedByUserLocal(newData.data.data.likedByUser);
      setLikeCountLocal(newData.data.data.likesTotales);
      setDisLikeCountLocal(newData.data.data.disLikesTotales);
  }

  const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

  const handleLikeClick = (likeType) => {
    if (!Context.gigyaContext.gigyaAccount) {
      const checkGuideCdc = localStorage.getItem("guideCdc");
      if (checkGuideCdc !== "true"){
          setIsOpenModal(true);
      } else {
          Context.gigyaContext.loginComfamaId!();
      }
    }
    else {
      saveLikeData(props.contentId, props.contentType, likeType == -1, likeType);
    }
  }

  useEffect(() => {
      setUtilFlag(!!props.utilidad);
      setReadOnly(!!props.readOnly);
  }, []);

  useEffect(() => {
      if (Context.gigyaContext.gigyaAccount) getLikesData();
  }, [Context.gigyaContext.gigyaAccount]);

  const zeroLikesMessage = "Mira el contenido y dale 'Me gusta'";

  const RenderedCmp = () => {
    if ( utilFlag ) {
      return (
        <div className="utilidad-btn-group">
          {props.textoBotones && 
          <div className="utilidad-btn-group-msg">
            <span className="utilidad-btn-group-msg-text">{props.textoBotones}</span>
          </div>}
          <div className="utilidad-btn-group-btns">
            <div className={`utilidad-btn-group-btns-${likedByUserLocal && likeTypeByUser == 1 ? "user" : "neutral"}`}>
              <button title="Muy útil" aria-label='Muy útil' className="btn_si" onClick={()=> handleLikeClick(likedByUserLocal && likeTypeByUser == 1 ? -1 : 1)}>
                <svg width="28" height="28" viewBox="0 0 29.51 29.51" xmlns="http://www.w3.org/2000/svg"><g data-name="Grupo 16448"><g data-name="Grupo 7460"><path fill="#707070" stroke="#707070" d="M14.755 29.01A14.255 14.255 0 1129.01 14.755 14.271 14.271 0 0114.755 29.01zm0-27.51a13.256 13.256 0 1013.26 13.255 13.271 13.271 0 00-13.26-13.256z" data-name="Trazado 13530"/></g><g fill="#707070" stroke="#707070" data-name="Grupo 7461"><path d="M8.476 13.299a.385.385 0 01-.385-.38 2.379 2.379 0 01.582-1.548 1.847 1.847 0 012.5 0 2.344 2.344 0 01.567 1.537.386.386 0 01-.385.378h-.008a.386.386 0 01-.378-.393 1.567 1.567 0 00-.349-.984 1.084 1.084 0 00-1.4 0 1.605 1.605 0 00-.362 1 .386.386 0 01-.383.388z" data-name="Trazado 13531"/><path d="M18.154 13.299a.385.385 0 01-.385-.38 2.379 2.379 0 01.582-1.548 1.847 1.847 0 012.5 0 2.344 2.344 0 01.567 1.537.386.386 0 01-.385.378h-.008a.386.386 0 01-.378-.393 1.567 1.567 0 00-.349-.984 1.084 1.084 0 00-1.4 0 1.606 1.606 0 00-.362 1 .386.386 0 01-.383.388z" data-name="Trazado 13532"/></g><g data-name="Grupo 7462"><path fill="#707070" stroke="#707070" d="M9.311 16.963a.325.325 0 00-.3.446 6.03 6.03 0 005.722 3.892 6.128 6.128 0 005.768-3.921.325.325 0 00-.3-.449z" data-name="Trazado 13533"/></g></g></svg>
              </button>
              <span className="utilidad-btn-group-btns-y-txt">Me fue útil</span>
            </div>
            
            <div className={`utilidad-btn-group-btns-${likedByUserLocal && likeTypeByUser == 0 ? "user" : "neutral"}`}>
              <button title="Poco útil" aria-label='Poco útil' className="btn_no" onClick={()=> handleLikeClick(likedByUserLocal && likeTypeByUser == 0 ? -1 : 0)}>
                <svg width="28" height="28" viewBox="0 0 29.51 29.51" xmlns="http://www.w3.org/2000/svg"><g data-name="Grupo 7466"><g data-name="Grupo 7465"><g data-name="Grupo 7464"><path fill="#707070" stroke="#707070" d="M14.7 29.01a14.255 14.255 0 1114.255-14.255A14.271 14.271 0 0114.7 29.01zm0-27.511a13.256 13.256 0 1013.256 13.256A13.271 13.271 0 0014.7 1.499z" data-name="Trazado 13534"/></g></g><path fill="#707070" stroke="#707070" d="M10.031 22.313a.5.5 0 01-.48-.636 5.755 5.755 0 015.432-4.01 5.66 5.66 0 015.389 3.985.5.5 0 11-.964.266 4.581 4.581 0 00-4.425-3.252 4.671 4.671 0 00-4.471 3.286.5.5 0 01-.481.361z" data-name="Trazado 13535"/><path fill="#707070" stroke="#707070" d="M7.228 14.227a.5.5 0 01-.1-.988c.044-.01 2.843-.63 3.842-2.265a.5.5 0 11.853.521c-1.227 2.009-4.355 2.693-4.487 2.721a.489.489 0 01-.108.011z" data-name="Trazado 13536"/><path fill="#707070" stroke="#707070" d="M22.51 14.227a.5.5 0 01-.1-.011c-.132-.028-3.259-.712-4.487-2.721a.5.5 0 11.853-.521c1 1.64 3.814 2.259 3.842 2.265a.5.5 0 01-.1.988z" data-name="Trazado 13537"/></g></svg>
              </button>
              <span className="utilidad-btn-group-btns-n-txt">No me ayudó</span>
            </div>
          </div>
        </div>
      );
    }
    else if (readOnly) {
      return (
        <div className="like-btn-group">
          <div className="likes-neutral">
            <i className="icon-thumbs-up1" />
            <span className="likes-texto-btn">
              {likeCountLocal == 0 ?
                zeroLikesMessage
              :
                `A ${likeCountLocal} persona${likeCountLocal > 1 ? "s " : " "} le${likeCountLocal > 1 ? "s " : " "} gusta esto`
              }
            </span>
          </div>
          <div className="dislikes-neutral">
            <i className="icon-thumbs-down1" />
            <span className="likes-texto-btn">
              {disLikeCountLocal}
            </span>
          </div>
        </div>
      );
    }
    else if (props.soloContador) {
      return (
        <div className="like-btn-group">
          <div className={`likes-${likedByUserLocal && likeTypeByUser == 1? "user" : "neutral"}`}>
            <button onClick={()=> handleLikeClick(1)}>
                <i className="icon-thumbs-up1" />
                <span>
                  {likeCountLocal}
                </span>
                {props.textoBoton && <span className="likes-texto-btn">{props.textoBoton}</span>}
            </button>
          </div>
          <div className={`dislikes-${likedByUserLocal && likeTypeByUser == 0 ? "user" : "neutral"}`}>
            <button onClick={()=> handleLikeClick(0)}>
                <i className="icon-thumbs-down1" />
                <span>
                  {disLikeCountLocal}
                </span>
                {props.textoBoton && <span className="dislikes-texto-btn">{props.textoBoton}</span>}
            </button>
          </div>
        </div>
      );
    }
    else {
      return  (
        <div className="like-btn-group">
          <div className={`likes-desc-${likedByUserLocal && likeTypeByUser == 1 ? "user" : "neutral"}`}>
            <button onClick={()=> handleLikeClick(1)}>
              <i className="icon-thumbs-up1" />
              <span className="likes-texto-btn">
                {likeCountLocal == 0 ? zeroLikesMessage :
                likedByUserLocal && likeCountLocal == 1 ?
                    "Te gusta esto"
                    :
                    `A ${likedByUserLocal? " ti y a " : ""} ${likedByUserLocal && likeCountLocal > 1 ?
                            likeCountLocal - 1 :
                            likeCountLocal} persona${likedByUserLocal && likeCountLocal == 2 ?
                            "" :
                            likeCountLocal > 1 ? "s " : " "} le${likeCountLocal > 1 ? "s " : " "} gusta esto`}
              </span>
            </button>
          </div>
          <div className={`dislikes-desc-${likedByUserLocal && likeTypeByUser == 0 ? "user" : "neutral"}`}>
            <button onClick={()=> handleLikeClick(0)}>
              <i className="icon-thumbs-down1" />
              <span className="dislikes-texto-btn">
                {disLikeCountLocal}
              </span>
            </button>
          </div>
        </div>
      );
    }
  }

  return (
      <>
        <RenderedCmp/>
        {isOpenModal && (
            <ModalGuiaCdc showModal={isOpenModal} onClose={closeModal}/>
        )}
      </>
  );

}

export default LikeButtonGroup;